export const useStyles = (MUITheme) => ({
    registrationHeaderContainer: {
        padding: "25px 5%",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "nowrap",
        alignItems: "center",
        backgroundColor: MUITheme.palette.background.mainContent,
        [MUITheme.breakpoints.down("xs")]: {
            flexDirection: "column",
            alignItems: "flex-start",
        },
    },
    logoContainer: {
        "& h1": {
            width: 230,
            margin: 0,
            "& span": {
                "&:before": { color: MUITheme.palette.purple.main },
            },
            "& img": { width: "100%" },
            "@media(max-width:340px)": { display: "none" },
        },
    },
    headerLink: {
        textAlign: "right",
        "& span": {
            color: MUITheme.palette.text.lightGrey,
            fontFamily: MUITheme.typography.fontFamily,
            fontSize: 16,
            [MUITheme.breakpoints.down("sm")]: { display: "none" },
        },
        "& a": {
            color: MUITheme.palette.primary.main,
            fontSize: 16,
            fontWeight: 600,
            textDecoration: "none",
            "&:hover": {
                cursor: "pointer",
                textDecoration: "underline",
            },
        },
        [MUITheme.breakpoints.down("xs")]: { textAlign: "left" },
    },
});
